// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1njEz","rightAdornment":"Header_rightAdornment__162qF"};